import { media } from "src/styles/mixins";
import styled from "styled-components";

export const EndTurnSummaryWrapper = styled.div`
  position: relative;
  width: 100%;
  background-color: ${({ theme }) => theme.colors.background};

  ${media.up("LAPTOP")`
    border-top: none;
    padding-bottom: 24px;
  `}
`;

export const AverageWrapper = styled.div`
  display: flex;
  flex-direction: column;
  text-align: center;
`;

export const AverageHeading = styled.div`
  font-size: ${({ theme }) => theme.fonts.sizes.xxxxs};
  color: ${({ theme }) => theme.colors.accent};
  text-transform: uppercase;

  &::after {
    content: "";
  }
`;

export const AverageValue = styled.div`
  font-weight: ${({ theme }) => theme.fonts.weights.bolder};
  font-size: ${({ theme }) => theme.fonts.sizes.s};
  margin-top: 8px;
`;

export const AgreementWrapper = styled.div`
  display: flex;
  flex-direction: column;
  text-align: center;
  text-transform: uppercase;
`;

export const AgreementHeading = styled.div`
  font-size: ${({ theme }) => theme.fonts.sizes.xxxxs};
  color: ${({ theme }) => theme.colors.accent};
  margin-top: 10px;
`;

export const AverageAndAgreementWrapper = styled.div`
  display: flex;
  margin-top: 0;
  height: 100%;
  flex-direction: column;
  align-items: center;
  justify-content: flex-end;
`;
